// extracted by mini-css-extract-plugin
module.exports = {"content":"Textarea__content--1A-","bottomHint":"Textarea__bottomHint--Jdt"};